import { get } from '../utils/APIClient';

/**
 * Published gradebook results for the logged-in student.
 * Endpoint: GET student-assignments/performance
 * Unpublished results (resultStatus GRADING) are omitted by the server.
 */
export const getStudentPerformance = async ({ token, duration, subject }) => {
  const params = new URLSearchParams();
  if (duration) params.set('duration', duration);
  if (subject) params.set('subject', subject);
  const query = params.toString();
  return get({
    url: `student-assignments/performance${query ? `?${query}` : ''}`,
    token
  });
};
